import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { style: {"margin":"0 -10px 0 -12px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "d-block mb-2" }, "Critical Patients", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "fs-18 mb-3" }, "780", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "area",
              height: "130",
              options: _ctx.criticalPatients,
              series: _ctx.patients
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ]),
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"d-flex align-items-center mb-2 mt-2\"><span style=\"width:12px;height:2px;\" class=\"bg-primary d-inline-block me-2\"></span><span>Cardiology: <span class=\"fw-semibold\">280</span></span></div><div class=\"d-flex align-items-center mb-0\"><span style=\"width:12px;height:2px;\" class=\"bg-danger d-inline-block me-2\"></span><span>Orthopedics: <span class=\"fw-semibold\">600</span></span></div>", 2))
    ])
  ]))
}